import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { ConfirmDialogData } from '../dialog-data.model';

@Component({
  selector: 'lfw-form-close-error-dialog',
  templateUrl: './form-close-error-dialog.component.html',
  styleUrls: ['./form-close-error-dialog.component.css'],
  imports: [MatButton, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, TranslatePipe]
})
export class FormCloseErrorDialogComponent {
  readonly data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);

  isCancelButtonDefault(): boolean {
    return this.data.okIsDefault !== true;
  }
}
